import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-slide-navigation',
  standalone: true,
  imports: [],
  templateUrl: './slide-navigation.component.html',
  styleUrl: './slide-navigation.component.scss'
})
export class SlideNavigationComponent {
  canGoNext = input<boolean>(true);
  canGoPrevious = input<boolean>(true);
  showArrows = input<boolean>(true);
  next = output<void>();
  previous = output<void>();

  private touchStartX = 0;
  private touchStartY = 0;
  private touchStartTime = 0;
  private readonly SWIPE_THRESHOLD = 50;
  private readonly SWIPE_TIME_THRESHOLD = 500;

  onPreviousClick(event: MouseEvent): void {
    event.stopPropagation();
    this.previous.emit();
  }

  onNextClick(event: MouseEvent): void {
    event.stopPropagation();
    this.next.emit();
  }

  onTouchStart(event: TouchEvent): void {
    if (event.touches.length === 1) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      this.touchStartTime = Date.now();
    }
  }

  onTouchEnd(event: TouchEvent): void {
    if (event.changedTouches.length === 1) {
      const dx = event.changedTouches[0].clientX - this.touchStartX;
      const dy = event.changedTouches[0].clientY - this.touchStartY;
      const dt = Date.now() - this.touchStartTime;

      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > this.SWIPE_THRESHOLD && dt < this.SWIPE_TIME_THRESHOLD) {
        if (dx < 0 && this.canGoNext()) {
          this.next.emit();
        } else if (dx > 0 && this.canGoPrevious()) {
          this.previous.emit();
        }
      }
    }
  }
}
